import React, { useState, useRef, useEffect } from 'react';
import { BsChevronDown } from 'react-icons/bs';

const TopbarDropdown = ({ label, items = [], selected, onSelect }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const handleEscape = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const displayLabel = selected || label;

  return (
    <div className="fd-dropdown-wrapper" ref={ref}>
      <button
        className="fd-topbar-btn"
        type="button"
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen(!open)}
      >
        <span>{displayLabel}</span>
        <BsChevronDown className="fd-topbar-btn-icon" />
      </button>
      {open && (
        <div className="fd-topbar-dropdown" role="menu">
          {items.map((item) => {
            const isString = typeof item === 'string';
            const key = isString ? item : (item.key || item.label);
            const itemLabel = isString ? item : item.label;
            return (
              <button
                key={key}
                className={`fd-topbar-dropdown-item${selected === itemLabel ? ' active' : ''}`}
                role="menuitem"
                onClick={() => {
                  if (onSelect) onSelect(item);
                  setOpen(false);
                }}
              >
                {itemLabel}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TopbarDropdown;
